exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-test-question-card[data-v-0428dc3e] {\n  height: 70px !important;\n}\n.dropdown[data-v-0428dc3e] {\n  width: 100%;\n  position: relative;\n}\n.dropdown .dropdown-menu[data-v-0428dc3e] {\n  min-width: 0rem;\n  padding-top: 0px;\n}\n.dropdown .dropdown-content[data-v-0428dc3e] {\n  position: absolute;\n  pointer-events: all;\n}\n.bulma .dropdown-menu[data-v-0428dc3e] {\n  display: block;\n  visibility: hidden;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n}\n.bulma .dropdown.is-active .dropdown-menu[data-v-0428dc3e] {\n  visibility: visible;\n}", ""]);

// exports
